import React from 'react';
import { TruncateTooltip } from '../../../../common/components/truncate-tooltip/TruncateTooltip';
import Tag from '../../../../core/components/tag/Tag';
import { jobHeadDetailsSelector } from '../../../../store/selectors/jobsSelector';
import { useAppSelector } from '../../../../store/hooks';

const JobViewHead: React.FC = () => {
  const jobHead = useAppSelector(jobHeadDetailsSelector);
  return (
    <>
      {jobHead.map((ent, i) => <div key={i} className="head__inner-info-item">
        <TruncateTooltip value={ent.label} className="head__inner-info-item__label" />
        {ent.label === 'Customer type'
          ? <Tag label={ent.value?.toString() || 'Customer'} />
          : <TruncateTooltip value={ent.value ? ent.value.toString() : '-'} className="head__inner-info-item__value" />}
      </div>)}
    </>
  );
};

export default JobViewHead;
